import { Calendar, MessageSquare } from 'lucide-react'
import styles from '@styles/AdminPanel.module.css'
import { es } from 'date-fns/locale'
import PropTypes from 'prop-types'
import { format } from 'date-fns'

const RemindersSection = ({ reminders }) => {
  return (
    <div className={styles.remindersSection}>
      <h2>Recordatorios</h2>
      <div className={styles.remindersContainer}>
        {reminders.map(reminder => (
          <div key={reminder.id} className={styles.reminderCard}>
            <div className={styles.reminderIcon}>
              {reminder.type === 'citas' ? <Calendar size={20} /> : <MessageSquare size={20} />}
            </div>
            <div className={styles.reminderContent}>
              <p>{reminder.message}</p>
              <span>{format(reminder.timestamp, 'dd/MM/yyyy HH:mm', { locale: es })}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

RemindersSection.propTypes = {
    reminders: PropTypes.array.isRequired,
  }

export default RemindersSection
